import React from 'react';
import ReactDOM from 'react-dom';
const mainRefresherPortal = document.getElementById('main-app-content');

export const MainRefresherPortal = ({ children }: any) => {
  return mainRefresherPortal
    ? ReactDOM.createPortal(
        children,
        mainRefresherPortal
    ) : <></>
}
